module.exports = __webpack_public_path__ + "img/before5.38950293.png";